// extracted by mini-css-extract-plugin
export default {"h-separator":"Separator_h-separator__ULv47","v-separator":"Separator_v-separator__qlsaz"};